import { ModalDialog } from '@/scripts/theme/modal-dialog'
import { replaceAll } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import { type PickupAvailability } from '@/scripts/optional/pickup-availability'
import { type ProductModal } from '@/scripts/product/product-modal'
import { type VariantSelects } from '@/scripts/theme/variant-selects'
import { type VariantRadios } from '@/scripts/theme/variant-radios'
import { type ProductInfo } from '@/scripts/product/product-info'
import { ATTRIBUTES, SELECTORS } from '@/scripts/core/global'

export class QuickAddModal extends ModalDialog {
	static override htmlSelector = 'quick-add-modal'
	productElement?: HTMLElement
	modalContent: HTMLElement
	productId: string
	quantity: number
	uniqueId: string
	sourceFormId: string

	constructor() {
		super()
		this.modalContent = q.rs('[id^="QuickAddInfo-"]', this)
		this.productId = q.ra(this, 'data-uc-quick-add-product-id')
		this.quantity = parseInt(q.ra(this, 'data-uc-quick-add-quantity'))
		this.uniqueId = q.ra(this, 'data-uc-quick-add-unique-id')
		this.sourceFormId = q.ra(q.rs('form'), 'id')
	}

	override hide(preventFocus = false) {
		const cartNotification = q.rs<CartDrawer>('cart-drawer')
		if (cartNotification && this.openedBy)
			cartNotification.setActiveElement(this.openedBy)
		this.modalContent.innerHTML = ''

		if (preventFocus) this.openedBy = undefined
		super.hide()
	}

	override show(opener: HTMLElement, upsellFromVariantId?: string) {
		opener.setAttribute('aria-disabled', 'true')
		opener.setAttribute(ATTRIBUTES.loading, '')
		q.rs(SELECTORS.loadingOverlaySpinner, opener).classList.remove('hidden')
		fetch(q.ra(opener, 'data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					'text/html'
				)
				this.productElement = q.rs(
					'section[id^="MainProduct-"]',
					responseHTML.documentElement
				)
				console.log({ productElement: this.productElement })
				this.preventDuplicatedIDs()
				this.removeDOMElements()
				this.setInnerHTML(
					this.modalContent,
					this.productElement.innerHTML,
					upsellFromVariantId
				)
//				mediaLoader()

				if (window.Shopify && window.Shopify.PaymentButton) {
					window.Shopify.PaymentButton.init()
				}

				//if (window.ProductModel) window.ProductModel.loadShopifyXR()

				this.removeGalleryListSemantic()
				this.updateImageSizes()
				this.preventVariantURLSwitching()
				super.show(opener)
			})
			.finally(() => {
				opener.removeAttribute('aria-disabled')
				opener.removeAttribute(ATTRIBUTES.loading)
				q.rs(SELECTORS.loadingOverlaySpinner, opener).classList.add(
					'hidden'
				)
			})
	}

	preventVariantURLSwitching() {
		const variantPicker = this.modalContent.querySelector(
			'variant-radios,variant-selects'
		)
		if (!variantPicker) return

		variantPicker.setAttribute('data-update-url', 'false')
	}

	setInnerHTML(element: HTMLElement, html: string, variantId?: string) {
		html.replaceAll(
			this.sourceFormId,
			`${this.sourceFormId}-${this.uniqueId}`
		)
		let cleanHTML: Document | null = new DOMParser().parseFromString(
			html,
			'text/html'
		)
		cleanHTML
			.querySelectorAll('[data-uc-remove-quick-add]')
			?.forEach((el) => {
				el.remove()
			})
		cleanHTML
			.querySelectorAll('.product__column-sticky')
			?.forEach((el) => el.classList.remove('product__column-sticky'))
		cleanHTML.querySelectorAll('.product__media.media')?.forEach((el) => {
			el.classList.remove('media')
			el.classList.remove('media--transparent')
		})
		cleanHTML
			.querySelectorAll(`[data-uc-featured-media]`)
			?.forEach((el) => {
				el.setAttribute('data-uc-featured-media', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-form-source="primary"]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-form-source', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-info-source]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-info-source', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-media-source]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-media-source', 'quick-add')
			})
		cleanHTML.querySelectorAll('[data-source]')?.forEach((el) => {
			el.setAttribute('data-source', 'quick-add')
		})
		q.rs('[data-uc-quantity-input]', cleanHTML).setAttribute(
			'value',
			`${this.quantity}`
		)
		q.rs<HTMLInputElement>(
			'[data-uc-quantity-input]',
			cleanHTML
		).value = `${this.quantity}`
		// TODO: danny hot times
		// add some shit that lets you know to do the properties thing
		if (variantId) {
			cleanHTML
				.querySelector('product-form')
				?.setAttribute('data-upsell-variant-id', variantId)
		}

		// back to existing flow

		element.innerHTML = cleanHTML.body.innerHTML

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element
			.querySelectorAll('script')
			.forEach((oldScriptTag: HTMLScriptElement) => {
				if (!oldScriptTag.parentNode)
					throw new Error(
						'oldScriptTag.parentNode is null, cannot replace script'
					)
				const newScriptTag = document.createElement('script')
				Array.from(oldScriptTag.attributes).forEach((attribute) => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				})
				newScriptTag.appendChild(
					document.createTextNode(oldScriptTag.innerHTML)
				)
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
			})

		const variantRadios = q.os<VariantRadios>('variant-radios', element)
		if (variantRadios) {
			console.log('we got the variant radios', variantRadios)
			variantRadios.replaceVariantMedia()
		} else {
			console.log('the fuck the fuck', { element })
		}
		// force clear memory
		cleanHTML = null
	}

	removeDOMElements() {
		if (!this.productElement)
			throw new Error(
				'this.removeDOMElements called without this.productElement'
			)
		q
			.os<PickupAvailability>('pickup-availability', this.productElement)
			?.remove()
		q.os<ProductModal>('product-modal', this.productElement)?.remove()
		const modalDialogs = q.ol<ModalDialog>(
			'modal-dialog',
			this.productElement
		)
		if (modalDialogs) {
			modalDialogs.forEach((modal) => modal.remove())
		}
	}

	preventDuplicatedIDs() {
		if (!this.productElement)
			throw new Error(
				'this.preventDuplicatedIDs called without this.productElement'
			)
		const sectionId = q.ra(this.productElement, 'data-section')
		this.productElement.innerHTML = replaceAll(
			this.productElement.innerHTML,
			sectionId,
			`quickadd-${sectionId}`
		).replaceAll('<quickadd-main-product', '<main-product')
		const formComponents = q.ol<
			VariantSelects | VariantRadios | ProductInfo
		>('variant-selects, variant-radios, product-info', this.productElement)
		formComponents?.forEach((element) => {
			element.dataset.originalSection = sectionId
		})
	}

	removeGalleryListSemantic() {
		const galleryList = this.modalContent.querySelector(
			'[id^="Slider-Gallery"]'
		)
		if (!galleryList) return

		galleryList.setAttribute('role', 'presentation')
		galleryList
			.querySelectorAll('[id^="Slide-"]')
			.forEach((li) => li.setAttribute('role', 'presentation'))
	}

	updateImageSizes() {
		const product = q.rs('.product', this.modalContent)
		const desktopColumns = product.classList.contains('product--columns')
		if (!desktopColumns) return

		const mediaImages = q.ol<HTMLImageElement>(
			'.product__media img',
			product
		)
		if (!mediaImages) return

		let mediaImageSizes =
			'(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)'

		if (product.classList.contains('product--medium')) {
			mediaImageSizes = mediaImageSizes.replace('715px', '605px')
		} else if (product.classList.contains('product--small')) {
			mediaImageSizes = mediaImageSizes.replace('715px', '495px')
		}

		mediaImages.forEach((img: HTMLImageElement) =>
			img.setAttribute('sizes', mediaImageSizes)
		)
	}
}

export class CartOptionsModal extends ModalDialog {
	static override htmlSelector = 'cart-options-modal'
	productElement?: HTMLElement
	modalContent: HTMLElement
	productId: string
	quantity: number
	uniqueId: string
	sourceFormId: string

	constructor() {
		super()
		this.modalContent = q.rs('[id^="QuickAddInfo-"]', this)
		this.productId = q.ra(this, 'data-uc-quick-add-product-id')
		this.quantity = parseInt(q.ra(this, 'data-uc-quick-add-quantity'))
		this.uniqueId = q.ra(this, 'data-uc-quick-add-unique-id')
		this.sourceFormId = q.ra(q.rs('form'), 'id')
	}

	override hide(preventFocus = false) {
		const cartNotification = q.rs<CartDrawer>('cart-drawer')
		if (cartNotification && this.openedBy)
			cartNotification.setActiveElement(this.openedBy)
		this.modalContent.innerHTML = ''

		if (preventFocus) this.openedBy = undefined
		super.hide()
	}

	override show(opener: HTMLElement, upsellFromVariantId?: string) {
		opener.setAttribute('aria-disabled', 'true')
		opener.setAttribute(ATTRIBUTES.loading, '')
		q.rs(SELECTORS.loadingOverlaySpinner, opener).classList.remove('hidden')
		fetch(q.ra(opener, 'data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					'text/html'
				)
				this.productElement = q.rs(
					'section[id^="MainProduct-"]',
					responseHTML.documentElement
				)
				console.log({ productElement: this.productElement })
				this.preventDuplicatedIDs()
				this.removeDOMElements()
				this.setInnerHTML(
					this.modalContent,
					this.productElement.innerHTML,
					upsellFromVariantId
				)
				//mediaLoader()

				if (window.Shopify && window.Shopify.PaymentButton) {
					window.Shopify.PaymentButton.init()
				}

				//if (window.ProductModel) window.ProductModel.loadShopifyXR()

				this.removeGalleryListSemantic()
				this.updateImageSizes()
				this.preventVariantURLSwitching()
				super.show(opener)
			})
			.finally(() => {
				opener.removeAttribute('aria-disabled')
				opener.removeAttribute(ATTRIBUTES.loading)
				q.rs(SELECTORS.loadingOverlaySpinner, opener).classList.add(
					'hidden'
				)
			})
	}

	preventVariantURLSwitching() {
		const variantPicker = this.modalContent.querySelector(
			'variant-radios,variant-selects'
		)
		if (!variantPicker) return

		variantPicker.setAttribute('data-update-url', 'false')
	}

	setInnerHTML(element: HTMLElement, html: string, variantId?: string) {
		html.replaceAll(
			this.sourceFormId,
			`${this.sourceFormId}-${this.uniqueId}`
		)
		let cleanHTML: Document | null = new DOMParser().parseFromString(
			html,
			'text/html'
		)
		cleanHTML
			.querySelectorAll('[data-uc-remove-quick-add]')
			?.forEach((el) => {
				el.remove()
			})
		cleanHTML
			.querySelectorAll('.product__column-sticky')
			?.forEach((el) => el.classList.remove('product__column-sticky'))
		cleanHTML.querySelectorAll('.product__media.media')?.forEach((el) => {
			el.classList.remove('media')
			el.classList.remove('media--transparent')
		})
		cleanHTML
			.querySelectorAll(`[data-uc-featured-media]`)
			?.forEach((el) => {
				el.setAttribute('data-uc-featured-media', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-form-source="primary"]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-form-source', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-info-source]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-info-source', 'quick-add')
			})
		cleanHTML
			.querySelectorAll('[data-uc-product-media-source]')
			?.forEach((el) => {
				el.setAttribute('data-uc-product-media-source', 'quick-add')
			})
		cleanHTML.querySelectorAll('[data-source]')?.forEach((el) => {
			el.setAttribute('data-source', 'quick-add')
		})
		q.rs('[data-uc-quantity-input]', cleanHTML).setAttribute(
			'value',
			`${this.quantity}`
		)
		q.rs<HTMLInputElement>(
			'[data-uc-quantity-input]',
			cleanHTML
		).value = `${this.quantity}`
		// TODO: danny hot times
		// add some shit that lets you know to do the properties thing
		if (variantId) {
			cleanHTML
				.querySelector('product-form')
				?.setAttribute('data-upsell-variant-id', variantId)
		}

		// back to existing flow

		element.innerHTML = cleanHTML.body.innerHTML

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element
			.querySelectorAll('script')
			.forEach((oldScriptTag: HTMLScriptElement) => {
				if (!oldScriptTag.parentNode)
					throw new Error(
						'oldScriptTag.parentNode is null, cannot replace script'
					)
				const newScriptTag = document.createElement('script')
				Array.from(oldScriptTag.attributes).forEach((attribute) => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				})
				newScriptTag.appendChild(
					document.createTextNode(oldScriptTag.innerHTML)
				)
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
			})

		const variantRadios = q.os<VariantRadios>('variant-radios', element)
		if (variantRadios) {
			console.log('we got the variant radios', variantRadios)
			variantRadios.replaceVariantMedia()
		} else {
			console.log('the fuck the fuck', { element })
		}
		// force clear memory
		cleanHTML = null
	}

	removeDOMElements() {
		if (!this.productElement)
			throw new Error(
				'this.removeDOMElements called without this.productElement'
			)
		q
			.os<PickupAvailability>('pickup-availability', this.productElement)
			?.remove()
		q.os<ProductModal>('product-modal', this.productElement)?.remove()
		const modalDialogs = q.ol<ModalDialog>(
			'modal-dialog',
			this.productElement
		)
		if (modalDialogs) {
			modalDialogs.forEach((modal) => modal.remove())
		}
	}

	preventDuplicatedIDs() {
		if (!this.productElement)
			throw new Error(
				'this.preventDuplicatedIDs called without this.productElement'
			)
		const sectionId = q.ra(this.productElement, 'data-section')
		this.productElement.innerHTML = replaceAll(
			this.productElement.innerHTML,
			sectionId,
			`quickadd-${sectionId}`
		).replaceAll('<quickadd-main-product', '<main-product')
		const formComponents = q.ol<
			VariantSelects | VariantRadios | ProductInfo
		>('variant-selects, variant-radios, product-info', this.productElement)
		formComponents?.forEach((element) => {
			element.dataset.originalSection = sectionId
		})
	}

	removeGalleryListSemantic() {
		const galleryList = this.modalContent.querySelector(
			'[id^="Slider-Gallery"]'
		)
		if (!galleryList) return

		galleryList.setAttribute('role', 'presentation')
		galleryList
			.querySelectorAll('[id^="Slide-"]')
			.forEach((li) => li.setAttribute('role', 'presentation'))
	}

	updateImageSizes() {
		const product = q.rs('.product', this.modalContent)
		const desktopColumns = product.classList.contains('product--columns')
		if (!desktopColumns) return

		const mediaImages = q.ol<HTMLImageElement>(
			'.product__media img',
			product
		)
		if (!mediaImages) return

		let mediaImageSizes =
			'(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)'

		if (product.classList.contains('product--medium')) {
			mediaImageSizes = mediaImageSizes.replace('715px', '605px')
		} else if (product.classList.contains('product--small')) {
			mediaImageSizes = mediaImageSizes.replace('715px', '495px')
		}

		mediaImages.forEach((img: HTMLImageElement) =>
			img.setAttribute('sizes', mediaImageSizes)
		)
	}
}
